/**
 * replayOutcomeMessage — map a webhook-failure REPLAY error to a closed-set
 * outcome message (#935/#1417). Keys off the wire `error.code` (and HTTP status
 * as a fallback), never the human message. Extracted from the former bespoke
 * WebhookFailuresPage so both the resource action (`errorFeedback`) and any
 * remaining caller share ONE mapping.
 *
 * The six error outcomes:
 *   - REPLAY_PAYLOAD_UNAVAILABLE → payloadUnavailable
 *   - CONFLICT                   → alreadyResolved
 *   - 400                        → stillBroken
 *   - 404                        → notFound
 *   - 500                        → stillFailing
 *   - anything else              → unknown (with the raw detail interpolated)
 */
import { ApiError } from '@/lib/api';
import { ERROR_CODES } from '@lib/errorCodes';

export function replayOutcomeMessage(
  t: (key: string, opts?: Record<string, unknown>) => string,
  err: unknown,
): string {
  if (err instanceof ApiError) {
    if (err.code === ERROR_CODES.REPLAY_PAYLOAD_UNAVAILABLE) {
      return t('webhookFailures.replay.outcome.payloadUnavailable');
    }
    if (err.code === ERROR_CODES.CONFLICT) {
      return t('webhookFailures.replay.outcome.alreadyResolved');
    }
    if (err.status === 400) {
      return t('webhookFailures.replay.outcome.stillBroken');
    }
    if (err.status === 404) {
      return t('webhookFailures.replay.outcome.notFound');
    }
    if (err.status === 500) {
      return t('webhookFailures.replay.outcome.stillFailing');
    }
  }
  return t('webhookFailures.replay.outcome.unknown', {
    detail: err instanceof Error ? err.message : String(err),
  });
}
